// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.base-info[data-v-385816b4] {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  row-gap: 16px;
  width: 100%;
  gap: 10px;
  margin-bottom: 10px;
}
.base-info .base-info-item[data-v-385816b4] {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  color: #000;
  gap: 8px;
}
.base-info .base-info-item .label[data-v-385816b4] {
  text-align: right;
}
.base-info .base-info-item .label.is-edit[data-v-385816b4] {
  color: #1890ff;
}
.base-info .base-info-item .value[data-v-385816b4] {
  height: 32px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 6px;
  border: 1px solid #2a7ca7;
}
.base-info .base-info-item .value.hasData[data-v-385816b4] {
  background-color: #fff;
}
.base-info .base-info-item[data-v-385816b4] .el-input__inner {
  color: #333 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/FormItems/index.vue","webpack://./index.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;ACAF;ADRA;EAUI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,WAAA;EACA,QAAA;ACCJ;ADhBA;EAiBM,iBAAA;ACEN;ADDM;EACE,cAAA;ACGR;ADtBA;EAuBM,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,yBAAA;ACEN;ADDM;EACE,sBAAA;ACGR;ADlCA;EAmCM,sBAAA;ACEN","sourcesContent":["\n.base-info {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  row-gap: 16px;\n  width: 100%;\n  gap: 10px;\n  margin-bottom: 10px;\n  .base-info-item {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    color: #000;\n    gap: 8px;\n    .label {\n      text-align: right;\n      &.is-edit {\n        color: #1890ff;\n      }\n    }\n    .value {\n      height: 32px;\n      background-color: #f5f5f5;\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      padding-left: 6px;\n      border: 1px solid #2a7ca7;\n      &.hasData {\n        background-color: #fff;\n      }\n    }\n    ::v-deep .el-input__inner {\n      color: #333 !important;\n    }\n  }\n}\n",".base-info {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  row-gap: 16px;\n  width: 100%;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n.base-info .base-info-item {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  color: #000;\n  gap: 8px;\n}\n.base-info .base-info-item .label {\n  text-align: right;\n}\n.base-info .base-info-item .label.is-edit {\n  color: #1890ff;\n}\n.base-info .base-info-item .value {\n  height: 32px;\n  background-color: #f5f5f5;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding-left: 6px;\n  border: 1px solid #2a7ca7;\n}\n.base-info .base-info-item .value.hasData {\n  background-color: #fff;\n}\n.base-info .base-info-item ::v-deep .el-input__inner {\n  color: #333 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
